<template>
  <v-container fluid class="payrollentry-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tab
            :href="`#tab-payrollentry`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-file-document</v-icon>
            Payroll Entry
          </v-tab>
          <v-tab-item
            :value="'tab-payrollentry'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="7">
                    <p class="text-h5">Edit Payroll Entry</p>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <v-select
                        class="mb-4"
                        outlined
                        dense
                        persistent-hint
                        readonly
                        :items="employees.filter(x=>x.employeestatus=='Active').map(x => {return {text: x.employeename, value: x._id};})"
                        :value="initvalue.employeeid"
                        v-on:change="updateChangedValue($event, 'employeeid')"
                        placeholder="Employee"
                        single-line hint="Please choose the employee">
                      </v-select>
                      <v-select
                        class="mb-4"
                        outlined
                        dense
                        persistent-hint
                        :items="accounts.filter(x=>x.accountclass=='Payroll').map(x => {return {text: x.accountname, value: x._id};})"
                        :value="initvalue.accountid"
                        v-on:change="updateChangedValue($event, 'accountid')"
                        placeholder="Account"
                        single-line hint="Please choose the account">
                      </v-select>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'paydesc')"
                        v-bind:value="initvalue.paydesc"
                        placeholder="Description"
                        persistent-hint
                        single-line hint="Enter the description">
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-form>
                        <v-menu
                          ref="menu_paydate"
                          v-model="menu_paydate"
                          :close-on-content-click="false"
                          :return-value.sync="paydate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              persistent-hint
                              v-model="paydate"
                              placeholder="Entry Date"
                              v-bind="attrs"
                              v-on:change="updateChangedValue($event, 'paydate')"
                              v-bind:value="paydate"
                              v-bind:error="errorindex == 2"
                              v-on="on"
                              single-line hint="Entry Date"
                              >
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="paydate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_paydate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="updateChangedValue(paydate, 'paydate'); $refs.menu_paydate.save(paydate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      <v-text-field
                          outlined
                          dense
                          type="number"
                          class="mb-4"
                          placeholder="Increase Amount"
                          single-line hint="Increase Amount"
                          v-on:change="updateChangedValue($event, 'paycredit')"
                          v-on:input="checkIncreaseAmount"
                          oninput="if(this.value < 0) this.value = 0;"
                          v-bind:value="initvalue.paycredit"
                          v-model="initvalue.paycredit"
                          v-bind:error="errorindex == 4"
                          persistent-hint
                          >
                        </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-menu
                          ref="menu_postdate"
                          v-model="menu_postdate"
                          :close-on-content-click="false"
                          :return-value.sync="postdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              persistent-hint
                              v-model="postdate"
                              placeholder="Post Date"
                              v-bind="attrs"
                              v-on:change="updateChangedValue($event, 'postdate')"
                              v-bind:value="postdate"
                              v-bind:error="errorindex == 2"
                              v-on="on"
                              single-line hint="Post Date"
                              >
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="postdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_postdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="updateChangedValue(postdate, 'postdate'); $refs.menu_postdate.save(postdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-text-field
                          outlined
                          dense
                          persistent-hint
                          type="number"
                          class="mb-4"
                          single-line hint="Decrease Amount"
                          placeholder="Decrease Amount"
                          v-on:change="updateChangedValue($event, 'paydebit')"
                          v-on:input="checkDecreaseAmount"
                          oninput="if(this.value < 0) this.value = 0;"
                          v-bind:value="initvalue.paydebit"
                          v-model="initvalue.paydebit"
                          >
                        </v-text-field>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="7">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/payrollentry/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPayrollEntry()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      payrollentry: {},
      initvalue: {},
      valuetypes: ['Amount', 'Percentage'],
      paydate: null,
      postdate: null,
      menu_paydate: false,
      menu_postdate: false,
      errorindex: undefined,
    }
  },
  methods: {
    ...mapActions('PayrollEntry', ['updatePayrollEntry','getPayrollEntrysRequest']),
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('Employee', ['getEmployeesRequest']),
    editPayrollEntry() {
      this.payrollentry._id = this.initvalue._id;
      this.updatePayrollEntry(this.payrollentry);
      router.push('/payrollentry/list');
    },
    updateChangedValue(value, field){
      this.payrollentry[field] = value;
    },
    checkIncreaseAmount(){
      if(this.initvalue.paycredit>0){this.initvalue.paydebit=0; this.payrollentry.paydebit=0; }
    },
    checkDecreaseAmount(){
      if(this.initvalue.paydebit>0){this.initvalue.paycredit=0; this.payrollentry.paycredit=0;}
    },
  },
  computed: {
    ...mapState('PayrollEntry', ['isReceiving']),
    ...mapState('Account', ['accounts']),
    ...mapState('Employee', ['employees']),
  },
  created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'PayrollEntryList' });
    if(this.employees.length==0){this.getEmployeesRequest()}
    if(this.accounts.length==0){this.getAccountsRequest()}
    if( this.initvalue.paydate!==null){
      let d2 = new Date(this.initvalue.paydate);
      let month = d2.getMonth()<9 ? "0" + (d2.getMonth()+1).toString() : (d2.getMonth()+1).toString();
      this.paydate = d2.getFullYear() + "-" + month + "-" + d2.getDate();
    }
    if( this.initvalue.postdate!==null){
      let d2 = new Date(this.initvalue.postdate);
      let month = d2.getMonth()<9 ? "0" + (d2.getMonth()+1).toString() : (d2.getMonth()+1).toString();
      this.postdate = d2.getFullYear() + "-" + month + "-" + d2.getDate();
    }
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
